import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaArrowLeft } from "react-icons/fa";
import PrivacyPolicy from "../components/PrivacyPolicy";
import LanguageToggle from "../components/LanguageToggle";
import Logo from "../assets/seinhtayfont.png";

function PrivacyPolicyPage() {
  const { i18n, t } = useTranslation();
  const [currLang, setCurrLang] = useState(
    i18n.language === "my" ? "MM" : "EN"
  );

  return (
    <div
      className={`min-h-screen bg-white ${
        i18n.language === "en" ? "font-DoHyeon-Regular" : "font-Khyay-Regular"
      }`}
    >
      <header className="fixed top-0 z-50 flex w-full items-center bg-red-600 px-2">
        <Link to="/" className="mr-auto w-48 md:w-72">
          <img src={Logo} alt="Sein Htay" />
        </Link>
        <div className="mr-2 hidden md:block">
          <LanguageToggle currLang={currLang} setCurrLang={setCurrLang} />
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-4 pt-24 pb-16 md:pt-28">
        <Link
          to="/"
          className="mb-8 inline-flex items-center gap-2 text-red-600 transition hover:text-red-700"
        >
          <FaArrowLeft />
          <span>{t("privacy.back_home", "Back to Home")}</span>
        </Link>
        <PrivacyPolicy />
      </main>

      <div className="fixed bottom-4 right-4 md:hidden">
        <LanguageToggle currLang={currLang} setCurrLang={setCurrLang} />
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
